import { IconPlus } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useJobsPaged } from "@/common/artemis-operations/jobs";
import { BasePageContainer, CustomIcon, QueryGuard } from "@/components/base";
import { JobTable } from "@/components/jobs/job-table";
import { useActions } from "@/contexts/actions-context";
import { usePageTitle } from "@/contexts/page-title-context";
import { useWizards } from "@/contexts/wizard-context";

export const Route = createFileRoute(
	"/_authenticated/$orgSlug/workspaces/$workspaceId/jobs/",
)({
	component: ScheduledJobs,
});

function ScheduledJobs() {
	const { workspaceId } = Route.useParams();
	const { setTitle } = usePageTitle();
	const { setActions } = useActions();
	const { openJobCreateWizard } = useWizards();

	const list = useJobsPaged(workspaceId);

	useEffect(() => {
		setTitle("Scheduled Jobs");
		setActions([
			{
				type: "button",
				id: "new-job",
				// label: "New Job",
				icon: <CustomIcon icon={IconPlus} />,
				onClick: () => openJobCreateWizard(),
			},
		]);
		return () => setActions([]);
	}, [setTitle, setActions, openJobCreateWizard]);

	return (
		<QueryGuard isPending={list.loading} isError={list.isError}>
			<BasePageContainer>
				<JobTable
					data={list.rows}
					loading={list.isFetching}
					totalCount={list.totalCount}
					hasNextPage={list.hasNextPage}
					hasPreviousPage={list.hasPreviousPage}
					pageIndex={list.pageIndex}
					onNextPage={list.onNextPage}
					onPreviousPage={list.onPreviousPage}
					pageSize={50}
					manualSorting
					initialSorting={list.sort}
					onSortingChange={list.setSort}
					search={list.search}
					onSearchChange={list.setSearch}
					status={list.filters.status}
					onStatusChange={(v) => list.setFilter("status", v)}
					onRefresh={() => list.refetch()}
					workspaceId={workspaceId}
				/>
			</BasePageContainer>
		</QueryGuard>
	);
}
